/**
 * @module experince/product-selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// core modules
import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { APIError } from '@support/api/common/error.interface';
import { CartService } from '@support/api/common/retrieveServices.interface';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { EventsEmitter } from '@experience/imei-check/interfaces/imei.interface';

@Component({
  selector: 'tmo-service-details',
  templateUrl: './service-details.component.html',
  styleUrls: [
    '../../../../../../style-sheets/components/page-titles.component.scss',
    '../../../../../../style-sheets/components/dropdown.component.scss',
    '../../../../../../style-sheets/components/input-radio.component.scss',
    '../../../../../../style-sheets/components/input-checkbox.component.scss',
    '../../../../../../style-sheets/components/html-accordion.component.scss',
    '../../../../../../style-sheets/components/gallery.component.scss',
  ],
})
export class ServiceDetailsComponent implements OnInit, OnDestroy {
  public price: number;
  public showSpinner: boolean;
  @Input() public softGoodsAEMContent: ConfigData;
  /**
   * no plan needed flag to disable service blade
   */
  // @Input() public disableServiceBlade: boolean;
  /**
   * stores error message on api failure
   */
  @Input() public errorMessage: APIError[];
  /**
   * Array to store hardConflict notifications
   */
  @Input() public hardConflictNotifications: string[];
  /**
   * Array to store softConflict notifications
   */
  @Input() public softConflictNotification: string[];

  /**
   * Stores the error boolean value
   */
  @Input() public error: boolean;
  @Input() public eligibleServices: CartService[];
  @Output() public clickEvent: EventsEmitter = new EventEmitter<string>();
  @Input() public planFamilyName: boolean;
  constructor() {
    this.clickEvent = new EventEmitter<string>();
  }

  public ngOnInit(): void {}
  /**
   * Destroys the subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {}

  public handleClickEvent(event: string): void {
    this.clickEvent.emit(event);
  }
}
